import { NitroLoading } from 'nitro-components';
import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as loginActions from '../../auth/actions';
import * as routes from '../../routes/const';

class Auth0Redirect extends Component {
  componentWillMount() {
    const { legacyLogout } = this.props.actions;

    legacyLogout();
  }

  componentWillUpdate(nextProps) {
    const { isAuthenticated } = nextProps.auth;
    const { router } = this.context;
    if (!isAuthenticated) router.push(routes.LOGIN);
  }

  render() {
    return <NitroLoading center />;
  }
}

Auth0Redirect.propTypes = {
  actions: PropTypes.object.isRequired
};

Auth0Redirect.contextTypes = {
  router: PropTypes.object
};

function mapStateToProps(state) {
  return {
    auth: state.auth
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(loginActions, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Auth0Redirect);



// WEBPACK FOOTER //
// ./src/features/legacy-logout-sync/index.js